import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./UserNameAvatar.scss";
import PropTypes from "prop-types";
import ProfileCascade from "UIComponents/ProfileCascade";
import I18nHOC from "UIComponents/I18nHOC";
import LinkWithTooltip from "UIComponents/LinkWithTooltip";
import { colors } from "Constants";
import { ShareIcon } from "SvgComponents";
import { UserDetails } from "AppComponents/ArchivedComponents";

class UserNameAvatar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      id,
      name,
      profileImage,
      email,
      labelTags,
      profileCellStyle,
      profileCascadeStyle,
      profileCascadeDsVersion,
      showTooltip,
      shouldDynamicColor,
      isArchived,
      showArchivedInTooltip,
      showAvatar,
      avatarStyles,
      showArchivedText,
      customTooltip = null,
      t,
      profileTextStyle,
      showArchivedLabel,
      emptyTextLocale,
      emptyTextStyle,
      viewMode,
      customSubText,
      nameWithLink,
      customSubTextStyle = {},
      onProfileClick,
      linkStyles = {},
      userNameAvatarWrapper: UserNameAvatarWrapper,
      userNameAvatarWrapperProps,
      dsVersion,
      profileCascadeWrapper: ProfileCascadeWrapper,
      profileCascadeWrapperProps,
      tooltipPlacement = "top",
      tooltipContainerStyle = {},
      customNameClass,
      testId,
      dir,
      studentAlertsConfig,
    } = this.props;
    const showEmptyText =
      _.isEmpty(name) && _.isEmpty(email) && emptyTextLocale;
    if (showEmptyText) {
      return (
        <div className={classes.emptyText} style={emptyTextStyle}>
          {t(emptyTextLocale)}
        </div>
      );
    }

    const tooltipLabel =
      showArchivedInTooltip && isArchived ? `${name} (Archived)` : name;

    return (
      <LinkWithTooltip
        tooltip={customTooltip || tooltipLabel}
        placement={tooltipPlacement}
        linkStyles={linkStyles}
        isVisible={showTooltip && _.isNil(studentAlertsConfig)}
        trigger={["hover", "focus"]}
        tooltipContainerStyle={tooltipContainerStyle}
      >
        <UserNameAvatarWrapper {...userNameAvatarWrapperProps}>
          <div
            className={classes.profileCell}
            style={profileCellStyle}
            tabIndex="0"
          >
            {id == "ALL" ? (
              <div className={classes.allIconContainer}>
                <ShareIcon fill={colors.neutral400} />
              </div>
            ) : (
              <ProfileCascadeWrapper {...profileCascadeWrapperProps}>
                <ProfileCascade
                  items={[{ id, value: name, imageUrl: profileImage }]}
                  customStyle={profileCascadeStyle}
                  shouldDynamicColor={shouldDynamicColor}
                  isArchived={isArchived}
                  showAvatar={showAvatar}
                  avatarStyles={avatarStyles}
                  dsVersion={profileCascadeDsVersion}
                />
              </ProfileCascadeWrapper>
            )}
            <UserDetails
              email={email}
              name={name}
              isArchived={isArchived}
              labelTags={labelTags}
              showArchivedText={showArchivedText}
              viewMode={viewMode}
              profileTextStyle={profileTextStyle}
              showArchivedLabel={showArchivedLabel}
              customSubText={customSubText}
              customSubTextStyle={customSubTextStyle}
              onProfileClick={onProfileClick}
              nameWithLink={nameWithLink}
              dsVersion={dsVersion}
              customNameClass={customNameClass}
              testId={testId}
              dir={dir}
              studentAlertsConfig={studentAlertsConfig}
            />
          </div>
        </UserNameAvatarWrapper>
      </LinkWithTooltip>
    );
  }
}
UserNameAvatar.defaultProps = {
  profileCascadeStyle: { width: 32, height: 32 },
  showTooltip: true,
  viewMode: "NAME_AND_EMAIL",
  userNameAvatarWrapper: ({ children }) => children,
  userNameAvatarWrapperProps: {},
  profileCascadeWrapper: ({ children }) => children,
  profileCascadeWrapperProps: {},
};
UserNameAvatar.propTypes = {
  profileCascadeStyle: PropTypes.object,
  profileCascadeDsVersion: PropTypes.string,
  showTooltip: PropTypes.bool,
  userNameAvatarWrapper: PropTypes.node,
  userNameAvatarWrapperProps: PropTypes.object,
};

export default I18nHOC({ resource: ["common"] })(UserNameAvatar);
